import {Component, Input, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-countdown',
  templateUrl: 'countdown.component.html',
  styleUrls: ['countdown.component.scss']
})
export class CountdownComponent implements OnInit {
  @Input() start: string;
  @Input() end: string;

  hidden = false;

  days: Array<string>;
  hours: Array<string>;
  minutes: Array<string>;

  private timer: number;

  ngOnInit() {
    this.timer = setInterval(this.generateHtml.bind(this), 60 * 1000);
    this.generateHtml();
  }

  private generateHtml() {
    const now = new Date().getTime();
    const distanceStart = new Date(this.start).getTime() - now;
    const distanceEnd = new Date(this.end).getTime() - now;

    if (distanceStart <= 0) {
      clearInterval(this.timer);

      if (distanceEnd <= 0) {
        this.hidden = true;
      } else {
        this.days = ['0', '0'];
        this.hours = ['0', '0'];
        this.minutes = ['0', '0'];
      }

      return;
    }

    const days = Math.floor(distanceStart / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distanceStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distanceStart % (1000 * 60 * 60)) / (1000 * 60));

    this.days = String(days).split('');
    this.hours = String(hours).split('');
    this.minutes = String(minutes).split('');

    if (this.days.length < 2) {
      this.days.unshift('0');
    }

    if (this.hours.length < 2) {
      this.hours.unshift('0');
    }

    if (this.minutes.length < 2) {
      this.minutes.unshift('0');
    }
  }
}
